<template>
  <v-dialog
    v-model="$props.show"
    v-bind="modalSettings"
    @click:outside="closeModal()"
  >
    <v-card>
      <v-card-title v-if="useTitle">
        <slot name="title"></slot>
      </v-card-title>
      <v-divider v-if="showDividers" />
      <v-card-text v-if="useText" class="card-body">
        <slot name="text"></slot>
      </v-card-text>
      <v-divider v-if="showDividers" />
      <v-card-actions v-if="useActions">
        <slot name="actions"></slot>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import { computed } from '@vue/composition-api';

export default {
  props: {
    show: Boolean,
    close: {
      type: Function,
      default: null
    },
    persistent: {
      type: Boolean,
      default: false
    },
    maxWidth: {
      type: String,
      default: 'none'
    },
    showDividers: {
      type: Boolean,
      default: true
    }
  },
  setup (props, context) {
    const modalSettings = computed(() => ({
      persistent: props.persistent,
      maxWidth: props.maxWidth
    }));

    const activeSlots = computed(() => Object.keys(context.slots).filter(slot => !!context.slots[slot]));
    const useTitle = computed(() => activeSlots.value.includes('title'));
    const useText = computed(() => activeSlots.value.includes('text'));
    const useActions = computed(() => activeSlots.value.includes('actions'));

    const closeModal = () => (!props.persistent ? props.close() : null);

    return { modalSettings, useTitle, useText, useActions, closeModal };
  }
};
</script>

<style>
.card-body{
  padding-top: 1rem !important;
  padding-bottom: 1rem !important;
}

</style>
